import React from 'react';
import {
  DeliveryServices,
  FitConnectDeliveryServiceParams,
  Zustellwege
} from '../../api/govos.types';

// Currently in ODM are only fitconnect and behoerdenpostfach available
export type ZustellwegTypes =
  | 'mail'
  | 'efaparameterdelivery'
  | 'a3behoerdenpostfach'
  | 'fitcondeliveryservice';

export const AvailableZustellwege = [
  { value: 'fitcondeliveryservice', label: 'FIT-Connect' },
  { value: 'a3behoerdenpostfach', label: 'Behoerdenpostfach' },
  { value: 'mail', label: 'E-Mail' },
  { value: 'efaparameterdelivery', label: 'EFA Parameter' }
];

export interface ZustellwegParentState {
  selectedZustellwegType: ZustellwegTypes;
}

export interface FormProps {
  onSuccess?: () => void;
  primaryButtonClickCount: number;
  setPrimaryButtonClickCount: React.Dispatch<React.SetStateAction<number>>;
  isParentFormValid: boolean;
  parentState: ZustellwegParentState;
  startAppId: string | number;
  processId?: string | number;
  templateId?: string | number;
  zustellwege?: Zustellwege[];
  shouldSaveAsTemplate?: boolean;
  newTemplateName?: string;
}

export interface ZustellwegSubFormProps extends FormProps {
  deliveryServices: DeliveryServices[];
  serviceIndex: number;
}

export interface FitConnectFormProps extends FitConnectDeliveryServiceParams {
  serviceId: number;
}

export interface BehoerdenpostfachFormProps {
  serviceId: number;
}

export const isValidOdmZustellweg = (zustellwegType: ZustellwegTypes) => {
  return (
    zustellwegType === 'fitcondeliveryservice' ||
    zustellwegType === 'a3behoerdenpostfach'
  );
};
